export const title = 'Вы\u00A0покинули встречу';
export const subtitle = (
    <>
        Если у&nbsp;вас остались вопросы, вы&nbsp;можете вернуться ко&nbsp;встрече,
        <br />
        пока у&nbsp;нее не&nbsp;закончилось время
    </>
);
export const buttonText = 'Вернуться';
